/**
 * Reads and exports the reducers as defined by each resource module
 *
 * NOTE: this facilitates adding reducers via the CLI
 */

export { default as product } from './product/productReducers.js';
export { default as user } from './user/userReducers.js';

export { default as node } from './node/nodeReducers.js';
export { default as transition } from './transition/transitionReducers.js';
export { default as scene } from './scene/sceneReducers.js';
export { default as course } from './course/courseReducers.js';
export { default as contentModule } from './contentModule/contentModuleReducers.js';
export { default as study } from './study/studyReducers.js';
export { default as sponsor } from './sponsor/sponsorReducers.js';
export { default as studyUser } from './studyUser/studyUserReducers.js';
export { default as site } from './site/siteReducers.js';
export { default as userNode } from './userNode/userNodeReducers.js';
export { default as userModule } from './userModule/userModuleReducers.js';
export { default as evaluation } from './evaluation/evaluationReducers.js';
export { default as userEvent } from './userEvent/userEventReducers.js';
export { default as question } from './question/questionReducers.js';
export { default as answer } from './answer/answerReducers.js';
export { default as userEvaluation } from './userEvaluation/userEvaluationReducers.js';
export { default as userAnswer } from './userAnswer/userAnswerReducers.js';
export { default as resourceLink } from './resourceLink/resourceLinkReducers.js';
export { default as moduleCertificate } from './moduleCertificate/moduleCertificateReducers.js';
export { default as courseCertificate } from './courseCertificate/courseCertificateReducers.js';
export { default as siteLocation } from './siteLocation/siteLocationReducers.js';
export { default as certificateTemplate } from './certificateTemplate/certificateTemplateReducers.js';
export { default as userModuleMetric } from './userModuleMetric/userModuleMetricReducers.js';
export { default as userEvaluationQuestion } from './userEvaluationQuestion/userEvaluationQuestionReducers.js';
export { default as studyRole } from './studyRole/studyRoleReducers.js';
export { default as auditLog } from './auditLog/auditLogReducers.js';
export { default as metric } from './metric/metricReducers.js';
export { default as metricCategory } from './metricCategory/metricCategoryReducers.js';
export { default as userProfile } from './userProfile/userProfileReducers.js'; 
export { default as sentimentQuestion } from './sentimentQuestion/sentimentQuestionReducers.js'; 
export { default as sentimentAnswer } from './sentimentAnswer/sentimentAnswerReducers.js'; 




// WEBPACK FOOTER //
// modules/moduleReducers.js